import { Skeleton } from 'primereact/skeleton';
import { Card } from 'primereact/card';
import './TestSeriesSkeleton.scss';

export const TestSeriesSkeleton = () => {
    return (
        <section className="most-popular-series-container ia-container px-2">
            <div className="mock-test-listing-header">
                <Skeleton width="150px" height="2rem" />
            </div>

            <div className="most-popular-cards-container p-0" style={{ flex: 'none', display: 'block' }}>
                {[...Array(6)].map((_, index) => (
                    <Card key={index} className='custome-card ia-testlist mb-5' style={{ paddingTop: '0' }}>
                        <div className="grid m-0 align-items-center">
                            <div className='col-12 lg:col-3 p-0'>
                                <Skeleton width="100%" height="150px" className="ia-skeleton-image" />
                            </div>
                            <div className='col-12 lg:col-9'>
                                <div className='ia-testlist-header grid gap-3 align-items-center justify-content-between px-2 pt-2'>
                                    <div className='inline-flex align-items-start lg:align-items-center gap-3'>
                                        <Skeleton width="200px" height="1.5rem" />
                                        <Skeleton width="60px" height="1.2rem" borderRadius="12px" />
                                    </div>
                                    <div>
                                        <Skeleton width="120px" height="2.5rem" borderRadius="4px" />
                                    </div>
                                </div>

                                <div className='ia-testlist-subheader pb-3'>
                                    <div className='grid mt-3 px-2 align-items-center'>
                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                            <Skeleton shape="circle" size="18px" />
                                            <Skeleton width="100px" height="1rem" className="ml-2" />
                                        </div>
                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                            <Skeleton shape="circle" size="18px" />
                                            <Skeleton width="80px" height="1rem" className="ml-2" />
                                        </div>
                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                            <Skeleton shape="circle" size="18px" />
                                            <Skeleton width="60px" height="1rem" className="ml-2" />
                                        </div>
                                        <div className='col-6 lg:col-auto flex align-items-center'>
                                            <Skeleton shape="circle" size="18px" />
                                            <Skeleton width="120px" height="1rem" className="ml-2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </section>
    );
};